import React, { useState, useContext, useEffect } from "react";

import "./MultiTab.css";
import { PortalContext } from "../../../context/Provider";
import { setPasoMultiTab } from "../../../context/Actions/multiTab/multiTab";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { setListError } from "../../../context/Actions/registro/registro";
import { regexEmail, regexNombre } from "../../../../global/utils/expresionesRegulares";
import FlechaIzquierdaIcon from "../../../assets/images/generico/FlechaIzquierdaIcon";
import { GlobalContext } from "../../../../global/context/Provider";
const MultiTab = ({ tabs, dissmiss }) => {
  const {
    multiTabState,
    multiTabDispatch,
    registroState,
    registroDispatch,
  } = useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch, toasterState } = useContext(GlobalContext);

  const [numActivo, setNumActivo] = useState(0);
  const campos = [
    "nombre",
    "apellido",
    "email",
    "fecha_nacimiento",
    "idlocalidad",
    "domicilio",
    "telefono_movil",
  ];


  const isNombreApellidoError = (nombre) => {
    if (regexNombre.test(nombre)) {
      return false;
    }
    if (nombre === "") {
      return true;
    }
  };
  const isErrorEmail = (email) => {
    if (!regexEmail.test(email)) {
      return true;
    }
    if (email === "") {
      return true;
    }
    return false;
  };
  const isLocalidadError = (localidad) => {
    if (localidad !== undefined) {
      if (localidad === "") {
        return true;
      } else return false;
    } else {
      return true;
    }
  };
  const isEmptyError = (empty) => {
    if (empty === "") {
      return true;
    }
    return false;
  };
  const activarPestania = (num) => {
    if (num === 1) {
      let errx = Object.assign({}, registroState.registro.listError);
      errx.nombre = isNombreApellidoError(
        registroState.registro.usuario.nombre
      );
      errx.apellido = isNombreApellidoError(
        registroState.registro.usuario.apellido
      );
      errx.email = isErrorEmail(registroState.registro.usuario.email);
      errx.fecha_nacimiento = isEmptyError(
        registroState.registro.usuario.fecha_nacimiento
      );
      errx.idlocalidad = isLocalidadError(
        registroState.registro.usuario.idlocalidad
      );
      errx.domicilio = isEmptyError(registroState.registro.usuario.domicilio);
      //consulto nuevamente si ya tenia el error, ya que estoy validando contra el ws.
      if (!registroState.registro.listError.telefono_movil) {
        errx.telefono_movil = isEmptyError(
          registroState.registro.usuario.telefono_movil
        );
      }
      setListError(errx)(registroDispatch);
      let flgError = false;
      campos.forEach((item) => {
        if (errx[item]) flgError = true;
      });
      if (flgError) {
        showToaster(
          {
            texto:
              "Por favor, ingresá todos los campos requeridos en el formulario.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        setPasoMultiTab(num)(multiTabDispatch);
      }
    } else {
      setPasoMultiTab(num)(multiTabDispatch);
    }
  };

  useEffect(() => {
    if (multiTabState.multiTab === undefined) setNumActivo(0);
    else setNumActivo(multiTabState.multiTab.paso);
  }, [multiTabState]);

  return (
    <React.Fragment>
      <div
        onClick={numActivo === 0 ? dissmiss : () => activarPestania(0)}
        className="ptur-registro-flecha"
      >
        <FlechaIzquierdaIcon />
      </div>
      <div className="pestaniasContenedor bgc-grey95">
        {Array.isArray(tabs) &&
          tabs.length > 0 &&
          tabs.map((item, index) => {
            return (
              <div
                className={`pestaniaMultitab  ${
                  numActivo === index ? "bgc-latex10" : "usarHoverMultitab"
                }`}
                onClick={() => activarPestania(index)}
                key={index}
              >
                {numActivo === index && (
                  <div className="flecha bgc-latex10"></div>
                )}
                <div className="contTitulo">
                  <h2
                    className={`m-0 rb18m textCenter ${
                      numActivo === index ? "c-white" : "c-black10"
                    } ${
                      item.nombre === "Datos personales" ? "tituloMobile" : ""
                    }`}
                  >
                    {item.nombre}
                  </h2>
                </div>
              </div>
            );
          })}
      </div>
       {Array.isArray(tabs) &&
        tabs.length > 0 &&
        tabs.map((item, index) => {
          return (
            numActivo === index &&
            React.createElement(
              require(`../` + item.carpeta + `/` + item.componente).default,
              item.params
            )
          );
        })}        
    </React.Fragment>
  );
};
export default MultiTab;
